/**
 * HEADER MAIN MENU VIEW TEMPLATE
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

function Template({ messageId, values }) {

    return (

        <div className="submenu">
            <div className="submenu__link no-print">
                <FormattedMessage id={messageId} values={values}/>
            </div>
        </div>

    );

}

export default Template;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Header/templates/Header.subMenu.jsx